// Company information used in proposals and other branded content

const FOUNDED_DATE = new Date("2017-12-26");

export const getYearsInBusiness = () => {
  const now = new Date();
  let years = now.getFullYear() - FOUNDED_DATE.getFullYear();
  if (
    now.getMonth() < FOUNDED_DATE.getMonth() ||
    (now.getMonth() === FOUNDED_DATE.getMonth() && now.getDate() < FOUNDED_DATE.getDate())
  ) {
    years--;
  }
  return `${years}+`;
};

export const companyInfo = {
  name: "UniverseIT",
  tagline: "Services. Support. Solutions.",
  founded: "Summer 2017",
  location: "Houston, Texas",
  website: "https://universeit.com",
  email: "info@universeit.com",
  phone: "(832) 630-4902",
  
  // Key statistics for consistent messaging
  stats: {
    combinedExperience: "200+",
    combinedExperienceLabel: "Years Combined Experience",
    clientRetention: "98%",
    clientRetentionLabel: "Client Retention",
    staffRetention: "95%",
    staffRetentionLabel: "Staff Retention",
    founderMicrosoftYears: 19,
  },
  
  history: `UniverseIT is a Houston, Texas–based IT firm founded in Summer 2017 as Lonestar CIO by 19-year Microsoft veteran, Joe Eldridge. Lonestar CIO served as a way for Joe to continue his storied legacy of providing exceptional CIO and CTO services to clients all over the world.

Today, UniverseIT is a full-service IT firm that provides modern business solutions with a focus on enabling small/medium business and Academia. We've grown from a one-person consultancy to a team of dedicated professionals, each bringing unique expertise in Microsoft technologies, ERP systems, CRM implementations, and managed IT services.`,

  purpose: `Our mission is simple: To take your organization beyond the cloud – enabling you for universal success.

We believe technology should empower businesses, not complicate them. Every solution we implement is designed with your specific needs in mind, ensuring you get the tools and support necessary to thrive in today's digital landscape.`,

  values: [
    {
      title: "Passion",
      description: "We love our jobs. We love technology. If we didn't, we wouldn't be here. Period. Our passion is evident. That passion drives us to be better & to do better every single day. For us. And for you."
    },
    {
      title: "Client Centered",
      description: "We value our clients above all else. We are committed to always putting our clients' needs above even our own. UniverseIT will always revolve around 'U'"
    },
    {
      title: "Dedication",
      description: "UniverseIT is dedicated to our clients and seeing them succeed. We take immense pride in our clients and the work they do, as well as in UniverseIT and the work we do."
    },
    {
      title: "Integrity",
      description: "We're not here to sell you a bunch of stuff you don't need. We're here to find the right solution for your organization—even if it's not from us. We mean that."
    }
  ],

  differentiators: [
    {
      title: "Microsoft Expertise",
      description: "Founded by a 19-year Microsoft veteran, we bring deep expertise in the entire Microsoft ecosystem including Dynamics 365, Power Platform, and Microsoft 365."
    },
    {
      title: "Personalized Service",
      description: "We're not a faceless corporation. You'll work directly with our leadership team who are invested in your success."
    },
    {
      title: "End-to-End Solutions",
      description: "From initial consultation to ongoing support, we handle everything so you can focus on running your business."
    },
    {
      title: "Honest Recommendations",
      description: "We recommend what's right for you, even if it means suggesting a competitor's solution. Your success is our priority."
    }
  ],

  teamMembers: [
    {
      id: "joe-eldridge",
      name: "Joe Eldridge",
      title: "Founder & CEO",
      tags: ["IT Leadership", "Enterprise Architecture", "Digital Transformation"],
      bio: "With 30 years of technology experience and 19 years at Microsoft, Joe has a proven track record of leading successful IT initiatives. He specializes in IT infrastructure, enterprise architecture, and digital strategy.",
      image: "/team-joe.jpg"
    },
    {
      id: "darren-grover",
      name: "Darren Grover",
      title: "Dynamics 365 CRM Specialist",
      tags: ["D365", "HubSpot", "CRM", "AI Agents"],
      bio: "Darren has spent the last decade helping businesses get the most out of their CRM and business applications. Deep expertise in Microsoft technologies, Dynamics 365, CRM/ERP systems, and process automation.",
      image: "/team-darren.jpg"
    },
    {
      id: "david-hatfield",
      name: "David Hatfield",
      title: "D365 Business Central Expert",
      tags: ["D365", "Business Central", "ERP", "NAV", "GP"],
      bio: "David specializes in helping businesses streamline financial processes and modernize their ERP systems. Over 20 years of finance operations experience with 50+ successful implementations.",
      image: "/team-david.jpg"
    },
    {
      id: "rebecca",
      name: "Rebecca",
      title: "Business Central Consultant",
      tags: ["D365", "Business Central", "NAV", "ERP"],
      bio: "Rebecca is a Dynamics 365 Business Central and NAV expert with 16 full-cycle implementations. She specializes in ERP strategy, system integrations, and process automation.",
      image: "/team-rebecca.jpg"
    },
    {
      id: "erica-weldon",
      name: "Erica Weldon",
      title: "Data Analytics & Architecture",
      tags: ["Data", "Power BI", "Analytics", "Solver"],
      bio: "Erica is a data and analytics powerhouse, specializing in financial reporting, business intelligence, and data visualization with expertise in Solver and Power BI.",
      image: "/team-erica.jpg"
    },
    {
      id: "anthony",
      name: "Anthony",
      title: "Cybersecurity & Infrastructure",
      tags: ["Cybersecurity", "Infrastructure", "M365"],
      bio: "Anthony is an IT infrastructure and cybersecurity expert, specializing in network security, device management, and cloud-based IT solutions with expertise in Microsoft Intune and ConnectWise.",
      image: "/team-anthony.jpg"
    },
    {
      id: "james",
      name: "James",
      title: "Network & Security Expert",
      tags: ["Cybersecurity", "Infrastructure", "M365"],
      bio: "James is the go-to expert for networking, cybersecurity, and device management, ensuring businesses have secure, reliable, and efficient IT infrastructure.",
      image: "/team-james.jpg"
    },
    {
      id: "brittany",
      name: "Brittany",
      title: "Microsoft 365 & D365 Support",
      tags: ["M365", "D365"],
      bio: "Brittany is a Microsoft 365 and Dynamics 365 support specialist, dedicated to ensuring businesses get the most out of their technology through hands-on support.",
      image: "/team-brittany.jpg"
    },
    {
      id: "rob",
      name: "Rob",
      title: "BC & D365 Support",
      tags: ["D365", "Business Central"],
      bio: "Rob provides hands-on support for Dynamics 365 and Business Central environments, helping clients resolve issues and optimize their systems.",
      image: ""
    },
    {
      id: "ramya",
      name: "Ramya",
      title: "Business Central Consultant",
      tags: ["Business Central", "D365"],
      bio: "Ramya is a Business Central consultant specializing in ERP configuration, data migration, and process optimization for growing businesses.",
      image: ""
    },
    {
      id: "ethan",
      name: "Ethan",
      title: "Dynamics 365 Consultant",
      tags: ["D365"],
      bio: "Ethan is a Dynamics 365 consultant focused on helping organizations implement and customize their D365 environments for maximum business value.",
      image: ""
    },
    {
      id: "micaela",
      name: "Micaela",
      title: "Project Manager",
      tags: ["Microsoft", "Project Management"],
      bio: "Micaela is a project manager who ensures technology implementations stay on track, on budget, and aligned with client goals.",
      image: ""
    },
    {
      id: "beatriz",
      name: "Beatriz",
      title: "Web Developer",
      tags: ["Web Design", "Development"],
      bio: "Beatriz is a web developer specializing in modern web design and development, creating polished digital experiences for clients.",
      image: ""
    }
  ],

  caseStudies: [
    {
      id: "ford-biztalk",
      title: "Ford Motor Co. BizTalk Implementation",
      industry: "Automotive",
      summary: "Led a 6-month BizTalk implementation for Ford Motor Company, streamlining integration across multiple systems.",
      results: ["Reduced integration time by 60%", "Improved data accuracy", "Seamless cross-platform communication"]
    },
    {
      id: "academia-sis",
      title: "Student Information System Implementation",
      industry: "Education",
      summary: "Guided a complete SIS implementation after a previous failed attempt, providing expert consultation and support.",
      results: ["Successful implementation", "Improved student data management", "Ongoing support relationship"]
    }
  ]
};

export type TeamMember = typeof companyInfo.teamMembers[number];
export type CaseStudy = typeof companyInfo.caseStudies[number];
export type CompanyValue = typeof companyInfo.values[number];
